define(['./../_SegmentationUtil'], (_SegmentationUtil)=> {
    return [()=> {
        return {
            restrict: 'EA',
            controller: ['$element', '$q', 'brandingData', function ($element, $q, brandingData) {
                return _SegmentationUtil($element, $q.resolve(brandingData));
            }]
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/branding/BrandingSegmentationDirective.js